import ListComponent from './ListComponent';

export default ListComponent;
